/** Transloco key of the toast shown when a CIL modal or its data cannot be loaded. */
export const CIL_LOAD_ERROR_MESSAGE = 'Ocorreu um problema ao recuperar os dados. Tente novamente mais tarde.';
